import React, { useEffect, useState } from "react";
import {
  getFinalAuditReportApi,
  getFinalAuditReportExportApi,
} from "../../services/AuditService";
import { useParams } from "react-router-dom";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import { Spinner, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { format } from "date-fns";
import { FaInfo } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import {
  formatDateTimeWithAdd5Hours,
  getAssetScanStatusBadge,
} from "../../utilities";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import {
  searchAreaByDepartmentApi,
  searchAuditorBySession,
  SearchDepartmentBySessionIdApi,
} from "../../services/SearchService";
import { CustomTooltip } from "../../components/CustomTooltip";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
const assetStatusOption = [
  { label: "Verified", value: "VERIFIED" },
  { label: "Missing", value: "MISSING" },
  { label: "Misplaced", value: "MISPLACED" },
  { label: "Unassigned", value: "UNASSIGNED" },
  { label: "New", value: "NEW" },
];

const FinalAuditReport = () => {
  const { sessionId } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [statusOption, setStausOption] = useState(assetStatusOption);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [auditorOption, setAuditorOption] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [areaOption, setAreaOption] = useState([]);
  const [selectedArea, setSelecetdArea] = useState(null);
  const [selectedAuditor, setSelectedAuditor] = useState(null);
  const [param, setParam] = useState({
    query: "",
    status: "",
    page: "1",
    page_size: "10",
    auditor: "",
    department: "",
    area: "",
  });

  const getArea = (id) => {
    searchAreaByDepartmentApi(id)
      .then((res) => {
        setAreaOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getDepartment = () => {
    SearchDepartmentBySessionIdApi(sessionId)
      .then((res) => {
        setDepartmentOption(res?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getAuditor = () => {
    searchAuditorBySession(sessionId)
      .then((res) => {
        setAuditorOption(res?.data?.auditors || []);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getDetails = () => {
    setLoading(true);
    getFinalAuditReportApi(sessionId, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getDetails();
  }, [param]);

  useEffect(() => {
    getAuditor();
    getDepartment();
  }, []);

  useEffect(() => {
    setAreaOption([]);
    setSelecetdArea(null);
    if (selectedDepartment?.value) {
      getArea(selectedDepartment?.value);
    }
  }, [selectedDepartment]);

  useEffect(() => {
    const status = selectedStatus?.value || "";
    const auditor = selectedAuditor?.value || "";
    const department = selectedDepartment?.value || "";
    const area = selectedArea?.value || "";
    if (
      param?.status !== status ||
      param?.auditor != auditor ||
      param?.department !== department ||
      param?.area !== area
    ) {
      setParam((prev) => ({
        ...prev,
        status: status,
        auditor: auditor,
        department: department,
        area: area,
      }));
    }
  }, [selectedStatus, selectedAuditor, selectedDepartment, selectedArea]);

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleExport = (type) => {
    setExportLoading(true);

    getFinalAuditReportExportApi(sessionId, {
      ...param,
      ...(type === "excel" ? { export: "excel" } : {}),
      ...(type === "pdf" ? { export: "pdf" } : {}),
    })
      .then((res) => {
        let mimeType = "";
        let fileExtension = "";

        if (type === "excel") {
          mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = "xlsx";
        } else if (type === "pdf") {
          mimeType = "application/pdf";
          fileExtension = "pdf";
        }

        const blob = new Blob([res.data], { type: mimeType });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        // const customDate = `${today.getDate()}-${
        //   today.getMonth() + 1
        // }-${today.getFullYear()}`;
        a.download = `AuditSession-final-report_${formattedDate}.${fileExtension}`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  return (
    <div>
      <div className="mb-4">
        <div className="d-flex justify-content-between gap-1 flex-wrap">
          <div>
            <h2 className="text-primary">Scan Details</h2>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/auditsession">Session List</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={`/audit-session/${sessionId}`}>Session Details</Link>
              </li>
              <li className="breadcrumb-item active">Scan Details</li>
            </ol>
          </div>
          <div className="d-flex gap-3 align-self-center">
            <Dropdown>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                disabled={exportLoading || data?.length == 0}
              >
                {exportLoading ? (
                  <Spinner animation="border" size="sm" className="me-1" />
                ) : (
                  <FaDownload className="me-1" />
                )}
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleExport("pdf")}>
                  <BsFileEarmarkPdfFill className="me-1" />
                  PDF
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleExport("excel")}>
                  <PiMicrosoftExcelLogoFill className="me-1" />
                  Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between  flex-column flex-md-row gap-2 p-4">
          <div className="flex-fill flex-md-grow-0">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
          <div className="d-flex flex-wrap gap-2">
            <GlobalSearchableDropdown
              options={departmentOption}
              selected={selectedDepartment}
              onSelect={(item) => setSelectedDepartment(item)}
              placeholder="Department"
            />
            <GlobalSearchableDropdown
              options={areaOption}
              selected={selectedArea}
              onSelect={(item) => setSelecetdArea(item)}
              placeholder="Area"
            />
            <GlobalSearchableDropdown
              options={auditorOption}
              selected={selectedAuditor}
              onSelect={(item) => setSelectedAuditor(item)}
              placeholder="Auditor"
            />
            <GlobalSearchableDropdown
              options={statusOption}
              selected={selectedStatus}
              onSelect={(item) => setSelectedStatus(item)}
              placeholder="Status"
            />
          </div>
        </div>
        <div>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-4">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Scanned Code</th>
                    <th>Name</th>
                    <th>Allocated Area</th>
                    <th>Scaned Area</th>
                    <th>Responsible User</th>
                    <th>Auditor</th>
                    <th>Scanned Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={`/asset/${item?.asset?.id}/basic-details`}
                            className="fw-medium text-primary"
                          >
                            {item?.scanned_code || "-"}
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-1 cursor-pointer">
                            <span>{item?.asset?.name || "-"}</span>
                          </div>
                        </td>
                        <td>{item?.allocated_area?.name || "-"}</td>
                        <td>{item?.scanned_area?.name || "-"}</td>
                        <td>{item?.responsible_user?.name || "-"}</td>
                        <td>{item?.scanned_by?.name || "-"}</td>
                        <td>
                          {item?.scanned_at
                            ? format(item?.scanned_at, "dd MMM yyy")
                            : "-"}
                        </td>
                        <td>{getAssetScanStatusBadge(item?.status)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">
              <span>No data found</span>
            </div>
          )}

          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinalAuditReport;
